"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SearcherEmptyTitle = _interopRequireDefault(require("./components/SearcherEmptyTitle"));
var _SearcherEmptyHint = _interopRequireDefault(require("./components/SearcherEmptyHint"));
var _SearcherEmptyButton = _interopRequireDefault(require("./components/SearcherEmptyButton"));
var SearcherEmpty = function SearcherEmpty(_ref) {
  var dateText = _ref.dateText,
    label = _ref.label,
    hint = _ref.hint,
    onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children,
    isHotelOnly = _ref.isHotelOnly;
  return /*#__PURE__*/_react["default"].createElement(StyledSearcherEmpty, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_SearcherEmptyTitle["default"], {
    label: label,
    dateText: dateText,
    isHotelOnly: isHotelOnly
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_SearcherEmptyHint["default"], {
    hint: hint,
    hasButton: Boolean(onClick),
    isHotelOnly: isHotelOnly
  }), onClick && /*#__PURE__*/_react["default"].createElement(_SearcherEmptyButton["default"], {
    onClick: onClick
  })), children);
};
var StyledSearcherEmpty = _styledComponents["default"].div.withConfig({
  displayName: "SearcherEmpty__StyledSearcherEmpty",
  componentId: "sc-xubv1w-0"
})(["text-align:center;"]);
var _default = exports["default"] = SearcherEmpty;